import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-league-spartan font-bold text-black mb-6">
            Sobre <span className="text-red-primary">OEC</span>
          </h2>
          <div className="w-24 h-1 bg-yellow-primary mx-auto mb-8"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="text-gray-700 text-lg mb-6 leading-relaxed">
              Somos una compañía independiente en enseñanza de idiomas. Nos motivan tus metas y nos enorgullece ser parte del proceso para alcanzarlas. Sabemos lo importante que es aprender otro idioma para abrir puertas laborales, académicas y culturales.
            </p>
            <p className="text-gray-700 text-lg mb-6 leading-relaxed">
              Agradecemos la confianza de nuestros estudiantes y trabajamos cada día para brindarles el mejor servicio, con clases completamente personalizadas según sus objetivos.
            </p>
            <p className="text-gray-700 text-lg mb-6 leading-relaxed">
              Nuestro sistema se enfoca en desarrollar la fluidez, comprensión, pronunciación y gramática. Proveemos todas las herramientas necesarias para adquirir nuevo vocabulario, formar opiniones en tiempo real y participar en un entorno 100% inmersivo en el idioma en aprendizaje. Utilizamos la tecnología a nuestro alcance, creamos nuestros propios materiales de apoyo y cada día abrimos más oportunidades para el aprendizaje, con temas actuales e innovadores.
            </p>
            
            <div className="grid grid-cols-2 gap-4 mt-8">
              <motion.div
                className="text-center p-4 bg-pink-primary/10 rounded-lg"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                <div className="text-2xl font-bold text-red-primary">+3</div>
                <div className="text-sm text-gray-600">AÑOS<br />DE EXPERIENCIA</div>
              </motion.div>
              <motion.div
                className="text-center p-4 bg-yellow-primary/10 rounded-lg"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                <div className="text-2xl font-bold text-red-primary">+125</div>
                <div className="text-sm text-gray-600">ALUMNOS<br />QUE LOGRARON SUS METAS CON NOSOTROS</div>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="bg-gradient-to-br from-pink-primary to-red-primary rounded-2xl p-8 py-20 text-white relative overflow-hidden min-h-[500px]">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-yellow-primary/20 rounded-full translate-y-12 -translate-x-12"></div>
              <div className="absolute bottom-4 right-4 w-48 h-48 bg-no-repeat bg-contain opacity-100" style={{backgroundImage: 'url(/set/5.png)'}}></div>
              
              <div className="relative z-10">
                <h4 className="text-2xl font-semibold mb-4">¿Por qué OEC?</h4>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-yellow-primary rounded-full mr-3"></span>
                    Clases 100% en vivo, participativas y dinámicas
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-yellow-primary rounded-full mr-3"></span>
                    Instructores con nivel equivalente a C2 o Nativo
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-yellow-primary rounded-full mr-3"></span>
                    Horarios flexibles A.M. y P.M.
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-yellow-primary rounded-full mr-3"></span>
                    Planes económicos en todas nuestras modalidades de enseñanza
                  </li>
                </ul>
                <button
                  className="bg-yellow-primary text-black px-6 py-3 rounded-full font-semibold hover:bg-yellow-400 transition-colors duration-300"
                  onClick={() => window.open('https://wa.me/50364376585', '_blank')}
                >
                  CONTACTANOS HOY
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;